/**
 * Pattern-based redaction engine.
 * Replaces sensitive data with [REDACTED] before writing reports.
 */

export const DEFAULT_REDACTION_PATTERNS: (string | RegExp)[] = [
  /AKIA[A-Z0-9]{16}/g,
  /Bearer\s+[A-Za-z0-9\-._~+/]+=*/g,
  /-----BEGIN\s+(RSA\s+)?PRIVATE\sKEY-----[\s\S]*?-----END/g,
  /\/\/[^:]+:[^@]+@/g,
];

export function createRedactor(
  patterns: (string | RegExp)[],
): (text: string) => string {
  return (text: string): string => {
    let result = text;
    for (const pattern of patterns) {
      if (typeof pattern === 'string') {
        // Escape special regex characters and create a global regex
        const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        result = result.replace(new RegExp(escaped, 'g'), '[REDACTED]');
      } else {
        // Clone the regex to ensure global flag and reset lastIndex
        const flags = pattern.flags.includes('g') ? pattern.flags : pattern.flags + 'g';
        const cloned = new RegExp(pattern.source, flags);
        result = result.replace(cloned, '[REDACTED]');
      }
    }
    return result;
  };
}
